// extracted by mini-css-extract-plugin
export var orderSummary = "_tn-0";
export var showMoreLessButton = "_tn-1";